import React from 'react';

export const Header: React.FC = () => {
  return (
    <>
      <header className="h-16 bg-bg-secondary border-b border-border-subtle flex items-center px-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-accent-red rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-lg">TS</span>
          </div>
          <div>
            <h1 className="text-lg font-semibold text-text-primary">Template Stamper</h1>
            <p className="text-xs text-text-tertiary">Video Automation Platform</p>
          </div>
        </div>
      </header>
    </>
  );
};
